<div class="li-nav-submenu" [routerLinkActiveOptions]="{ exact: false }" routerLinkActive="isActive"
    [routerLink]="data.link" [id]="id">
    <div matPrefix routerLinkActive="isActive" class="li-nav-submenu__icon">
        <v-icon [name]="data.icon"></v-icon> 
    </div>
    <span class="li-nav-submenu__text" (click)="onClick($event)">
        <ng-content></ng-content>
    </span>
</div>